<template>
  <div class="min-h-screen relative">
    <Header />

    <div
      class="min-h-screen container mx-auto max-w-[1200px] w-full mb-10 py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <div
        v-if="loading"
        class="flex items-center justify-center"
        style="height: calc(100vh - 350px) !important"
      >
        <img src="@/assets/newd/loading.gif" alt="" />
      </div>
      <div v-else class="p-4">
        <div class="flex flex-wrap gap-3 mb-6">
          <div
            v-if="sem_course.length == 0"
            class="flex justify-center w-full sm:p-6 h-auto bg-gray-50 border border-dashed border-gray-200 rounded-xl"
          >
            <p class="text-sm font-medium text-gray-500">No Semesters Available</p>
          </div>

          <!-- <div v-for="tab in sem_course" :key="tab.semester">
            <button
             v-if="semesterToNumber(tab.semester) <= semesterToNumber(userInfo.current_semester.semester)"
              @click="selectTab(tab)"
              :class="[
                'px-4 py-2 rounded text-sm transition duration-200',
                activeTab === tab.semester &&
                activeDepartment === tab.department.name
                  ? 'bg-blues text-white'
                  : semesterToNumber(tab.semester) <=
                    semesterToNumber(userInfo.current_semester.semester)
                  ? 'bg-gray-200 border text-gray-700 hover:bg-gray-300'
                  : 'bg-gray-200 text-gray-500 hover:bg-gray-300',
              ]"
            >
              Semester <b class="pl-1">{{ tab.semester }}</b>
              <span
                class="ml-2 text-xs font-bold"
                :class="
                  activeTab === tab.semester &&
                  activeDepartment === tab.department.name
                    ? 'text-white'
                    : 'text-gray-600'
                "
              >
                ({{ tab.department.name }})
              </span>
            </button>
          </div> -->

          <!-- new -->
          <!-- <div v-for="tab in sem_course" :key="tab.id">
            <button
              @click="selectTab(tab)"
              :class="[
                'px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 shadow-sm border',
                activeSemesterId === tab.id &&
                activeDepartment === tab.department.name
                  ? 'bg-blues text-white border-blues shadow-blue-500/30'
                  : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50',
              ]"
            >
              Semester {{ tab.semester }}
              <span
                class="ml-1.5 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider"
                :class="
                  activeSemesterId === tab.id &&
                  activeDepartment === tab.department.name
                    ? 'bg-white text-black'
                    : 'bg-gray-100 text-gray-600'
                "
                >{{ tab.department.name }}</span
              >
            </button>
          </div> -->
        </div>

        <div v-if="activeTab">
          <div class="flex flex-row items-center justify-between mt-2 mb-2">
            <h2 class="text-gray-900 text-2xl sm:text-3xl font-bold tracking-tight">
              My Courses
            </h2>
          </div>

          <div class="">
            <div v-if="this.getCourseListbySemester.length > 0">
              <div
                v-if="getCourseListbySemester[0]"
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6"
              >
                <div
                  v-for="course in this.getCourseListbySemester[0].course ||
                  this.getCourseListbySemester[0]"
                  :key="course.id"
                  class="bg-white border border-gray-100 shadow-md hover:shadow-xl rounded-2xl p-4 sm:p-5 h-full transition-all duration-300 flex flex-col"
                  :class="{
                    'cursor-not-allowed bg-gray-50 opacity-70':
                      this.getCourseListbySemester[0].id >
                      userInfo.current_semester.id,
                    'cursor-pointer':
                      this.getCourseListbySemester[0].id <=
                      userInfo.current_semester.id,
                  }"
                  @click="
                    this.getCourseListbySemester[0].id <=
                    userInfo.current_semester.id
                      ? getDashboardOrPreviewUp(course.id)
                      : null
                  "
                >
                  <div class="flex-1 flex flex-col h-full">
                    <div class="relative flex justify-center items-center overflow-hidden rounded-xl group">
                      <img
                        v-if="course.thumbnail"
                        class="object-cover h-[180px] sm:h-[200px] w-full transition-transform duration-500 group-hover:scale-110"
                        :src="course.thumbnail"
                        alt="Course Thumbnail"
                      />
                      <img
                        v-else
                        class="object-cover h-[180px] sm:h-[200px] w-full transition-transform duration-500 group-hover:scale-110 object-top"
                        src="@/assets/coding.svg"
                        alt="Placeholder"
                      />
                      <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300 pointer-events-none"></div>
                    </div>
                    <div class="text-left flex flex-col gap-3 mt-5 flex-1">
                      <h3
                        class="text-base sm:text-lg text-gray-900 font-bold line-clamp-2 leading-tight"
                      >
                        {{ course.title }}
                      </h3>

                      <p class="text-xs sm:text-sm text-gray-600 text-left mt-auto pt-1">
                        <span class="font-bold">Course Code:</span>
                        {{ course.course_code }}
                      </p>

                      <p
                        class="text-xs sm:text-sm text-gray-500 mt-1"
                        v-if="course.instructor || course.instructor_name"
                      >
                        <span class="font-medium text-gray-700">Instructor:</span>
                        {{ course.instructor || course.instructor_name }}
                      </p>
                      
                      <div class="mt-4 pt-1">
                        <button
                          @click.stop="
                            this.getCourseListbySemester[0].id <=
                            userInfo.current_semester.id
                              ? getDashboardOrPreviewUp(course.id)
                              : null
                          "
                          :class="{
                            'cursor-not-allowed bg-gray-100 text-gray-400':
                              this.getCourseListbySemester[0].id >
                              userInfo.current_semester.id,
                            'cursor-pointer bg-blues hover:bg-hover text-white shadow-md hover:shadow-lg':
                              this.getCourseListbySemester[0].id <=
                              userInfo.current_semester.id,
                          }"
                          class="w-full py-2.5 px-4 text-sm rounded-xl font-semibold text-center transition-all duration-300 flex items-center justify-center gap-2 transform active:scale-95"
                        >
                          Continue Learning
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="this.getCourseListbySemester[0].course.length == 0"
                  class="bg-white border border-dashed border-gray-200 rounded-xl p-8 h-auto flex flex-col items-center justify-center text-center col-span-full"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-gray-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477-4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  <p class="text-lg font-medium text-gray-900">No Courses Available</p>
                  <p class="text-sm text-gray-500 mt-1">Courses for this semester will appear here once published.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Student/Header.vue";

export default {
  data() {
    return {
      profileInfo: null,
      popUp: false,
      updateDetails: null,
      selectedFile: null,
      tnxDetails: "",
      profile: false,

      selectedcontent: "Courses",
      courseDetails: [],
      boughtcourse: null,
      progress: 90,
      loading: true,
      activeTab: null,
      sem_course: [],
      sem_courselist: [],
      getCourseListbySemester: [],
    };
  },

  components: {
    Header,
    Footer,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    if (!localStorage.getItem("previewIgnoreList")) {
      localStorage.setItem("previewIgnoreList", JSON.stringify([]));
    }
  },

  async created() {
    this.getsemester();

    await axios
      .get(
        `${process.env.VUE_APP_API}/studentsbuycoursedetails/?Key=${this.userInfo.token_key}`,
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.courseDetails = response.data.data;
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      });
  },

  methods: {
    semesterToNumber(sem) {
      const map = { I: 1, II: 2, III: 3, IV: 4, V: 5, VI: 6 };
      return map[sem] || 0;
    },
     canAccessSemester() {
    if (!this.getCourseListbySemester.length) return false;

    const currentSemester = this.semesterToNumber(
      this.userInfo.current_semester.semester
    );

    const selectedSemester = this.semesterToNumber(
      this.getCourseListbySemester[0].semester
    );

    return selectedSemester <= currentSemester;
  },
    isDisabled(tab) {
      const current = this.semesterToNumber(
        this.userInfo.current_semester.semester,
      );
      const tabSem = this.semesterToNumber(tab.semester);
      return tabSem > current;
    },
    selectTab(tab) {
      this.activeSemesterId = tab.id;
      this.activeTab = tab.semester;
      this.activeDepartment = tab.department.name;
      this.getsemestercourse(tab.id);
    },

    getDashboardOrPreviewUp(id) {
      if (localStorage.getItem("previewIgnoreList")) {
        let preList = new Set(
          JSON.parse(localStorage.getItem("previewIgnoreList")),
        );

        if (preList.size != 0) {
          if (preList.has(id.toString())) {
            this.$router.push({
              name: "StudentCourseProgress",
              params: { course_id: id },
            });
          } else {
            this.$router.push({
              name: "StudentCourse",
              params: { courseid: id },
            });
          }
        } else {
          this.$router.push({
            name: "StudentCourse",
            params: { courseid: id },
          });
        }
      } else {
        this.$router.push({ name: "StudentCourse", params: { courseid: id } });
      }
    },

    // new
    async getsemester() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student-semester-get/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.sem_course = response.data.data.data[0].semester.reverse();
            const currentSem = this.userInfo.current_semester.id;
            const currentDepartment = this.userInfo.current_semester.department;
            const found = this.sem_course.find(
              (tab) =>
                tab.id === currentSem &&
                tab.department.name === currentDepartment,
            );

            if (found) {
              this.activeSemesterId = found.id;
              this.activeTab = found.semester;
              this.activeDepartment = found.department.name;

              this.getsemestercourse(found.id);
            } else if (this.sem_course[0]) {
              this.activeSemesterId = this.sem_course[0].id;
              this.activeTab = this.sem_course[0].semester;
              this.activeDepartment = this.sem_course[0].department.name;

              this.getsemestercourse(this.sem_course[0].id);
            }

            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        });
    },

    async getsemestercourse(id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student-semester-get/${this.userInfo.user.id}/?semester__id=${id}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            const semesterData = response.data.data.data[0].semester;

            this.getCourseListbySemester = semesterData.map((sem) => ({
              ...sem,
              course: sem.course.filter(
                (course) => course.published_course?.published === true,
              ),
            }));
          }
        });
    },
  },
};
</script>

<style scoped></style>
